import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import api from "@/lib/api";

const todayIso = () => new Date().toLocaleDateString("en-CA");
const daysUntil = (iso) => Math.round((new Date(`${iso}T00:00:00`) - new Date(`${todayIso()}T00:00:00`)) / 86400000);
const label = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
const short = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short" });

// Next public holiday with a day countdown, plus the two after it.
export const HolidayCountdown = ({ className = "" }) => {
    const [next, setNext] = useState(null);

    useEffect(() => {
        const y = new Date().getFullYear();
        Promise.all([y, y + 1].map((year) => api.get("/holidays", { params: { year } }).then((r) => r.data || []).catch(() => [])))
            .then(([a, b]) => setNext([...a, ...b].filter((h) => h.date >= todayIso()).slice(0, 3)));
    }, []);

    if (!next || next.length === 0) return null;
    const [h, ...later] = next;
    const d = daysUntil(h.date);
    return (
        <div className={`bg-white border border-ink/10 p-6 flex flex-wrap items-center gap-6 ${className}`} data-testid="holiday-countdown">
            <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-2xl bg-klein/10 text-klein flex flex-col items-center justify-center shrink-0">
                    <span className="font-display font-extrabold text-2xl leading-none tabular-nums" data-testid="holiday-countdown-days">{d}</span>
                    <span className="text-[10px] font-semibold uppercase tracking-wider">{d === 1 ? "day" : "days"}</span>
                </div>
                <div>
                    <div className="overline flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5" /> Next public holiday</div>
                    <div className="mt-1 font-display font-bold text-lg text-ink" data-testid="holiday-countdown-name">{d === 0 ? `Today: ${h.name}` : h.name}</div>
                    <div className="text-sm text-ink/55">{label(h.date)}</div>
                </div>
            </div>
            {later.length > 0 && (
                <div className="ml-auto flex flex-wrap gap-2" data-testid="holiday-countdown-later">
                    {later.map((x) => (
                        <span key={x.id} className="text-xs border border-ink/10 rounded-full px-3 py-1.5 text-ink/65">
                            <b className="text-ink">{short(x.date)}</b> · {x.name}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HolidayCountdown;
